"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var QueryBuilder = /** @class */ (function () {
    function QueryBuilder() {
        this.query = {};
    }
    QueryBuilder.prototype.addSort = function (fieldName, order) {
        if (order === void 0) { order = null; }
        this.query.sort = tslib_1.__spread((this.query.sort || []), [{ fieldName: fieldName, order: order }]);
        return this;
    };
    QueryBuilder.prototype.addPaging = function (limit, offset) {
        if (offset === void 0) { offset = null; }
        this.query.paging = { limit: limit, offset: offset };
        return this;
    };
    QueryBuilder.prototype.addFilter = function (filter) {
        this.query.filter = this.query.filter || {};
        Object.assign(this.query.filter, filter);
        return this;
    };
    QueryBuilder.prototype.build = function () {
        return { query: this.query };
    };
    return QueryBuilder;
}());
exports.QueryBuilder = QueryBuilder;
//# sourceMappingURL=QueryBuilder.js.map